var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V20H25V0H0ZM1 1H24V14H18.6602L15.1602 11.5H12.207L10.1641 9.45703L7.73047 9.94531L5.57812 6.71484L1 11.293V1ZM16.5 6.25C16.5 5.01367 17.5137 4 18.75 4C19.9863 4 21 5.01367 21 6.25C21 7.48633 19.9863 8.5 18.75 8.5C17.5137 8.5 16.5 7.48633 16.5 6.25ZM18.75 5C19.4453 5 20 5.55469 20 6.25C20 6.94531 19.4453 7.5 18.75 7.5C18.0547 7.5 17.5 6.94531 17.5 6.25C17.5 5.55469 18.0547 5 18.75 5ZM7.26953 11.0547L5.42188 8.28516L1 12.707V19H24V15H18.3398L14.8398 12.5H11.793L9.83594 10.543L7.26953 11.0547Z",
    fill: "#62AA51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPic);
export default __webpack_public_path__ + "static/media/pic.4eba9cff9a79e3a433d97323d8702fed.svg";
export { ForwardRef as ReactComponent };